import React, { useState } from 'react';
import { connect } from 'react-redux';
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Box,
  Dialog, DialogContent, DialogActions, Button, Modal, Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FaDownload } from "react-icons/fa";
import { IoMdEye } from "react-icons/io";
import AdmCheckListPdf from './AdmCheckListPdf';
import moment from 'moment';
import HttpService from '../../services/httpService';
import { FaExternalLinkAlt } from "react-icons/fa";

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
  },
  headerCell: {
    backgroundColor: '#F47E46',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '18px',
    padding: '20px',
    borderRight: '1px solid rgba(255,255,255,0.2)',
    position: 'sticky',
    top: 0,
    textAlign: 'center',
    zIndex: 1,
  },
  tableRowEven: {
    backgroundColor: '#ffffff',
  },
  tableRowOdd: {
    backgroundColor: '#f0f4f8',
  },
  cell: {
    fontSize: '16px',
    padding: '20px',
    borderRight: '1px solid #e0e0e0',
    color: '#263238',
  },
  valueCell: {
    fontSize: '18px',
    fontWeight: 'bold',
    padding: '20px',
    color: 'black',
    borderRight: '1px solid #e0e0e0',
    textAlign: 'center',
  },
}));

const styleForPopup = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const DrawingQCLogs = (props) => {
  const classes = useStyles();
  const [aDMModalOpen, setADMModalOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [modalTitle, setModalTitle] = useState('Attachments');

  const data = props.projectDetails;

  const handleDownloadAll = (urls = []) => {
    urls.forEach((url, index) => {
      setTimeout(() => {
        const link = document.createElement('a');
        link.href = url;
        link.download = '';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }, index * 500);
    });
  };

  const handleOpen = (files, title = 'Attachments') => {
    setSelectedFiles(files || {});
    setModalTitle(title);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);
  const handleOpenADMModal = () => setADMModalOpen(true);
  const handleCloseADMModal = () => setADMModalOpen(false);

  const quoClick = async (data) => {
    try {
      const fileUrl = data?.[0];
      if (!fileUrl) {
        console.warn("No file URL provided in data");
        return;
      }

      // Check if fileUrl has a PDF extension
      if (fileUrl.toLowerCase().endsWith(".pdf")) {
        if (fileUrl && typeof fileUrl === 'string') {
          window.open(fileUrl, '_blank'); 
        } else {
          console.warn("Invalid link returned from API");
        }
      }

      const response = await HttpService.quotationLink(data[0]);
      const link = response?.data?.links[0];
      if (link && typeof link === 'string') {
        window.open(link, '_blank'); 
      } else {
        console.warn("Invalid link returned from API");
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }

  return (
    <div className="App">
      <Box className={classes.root}>
        <TableContainer component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>User</TableCell>
                <TableCell className={classes.headerCell}>Drawing QC Stages</TableCell>
                <TableCell className={classes.headerCell}>Approved/Uploaded Time</TableCell>
                <TableCell className={classes.headerCell}>Designer and QC Uploaded Files</TableCell>
                <TableCell className={classes.headerCell}>Remarks by Designer and QC </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {/* ADM Approval */}
              {data?.drawingQcAdmApprovedAt && (
                <TableRow>
                  <TableCell className={classes.valueCell}>{data?.checkListDesignerSignatureName}</TableCell>
                  <TableCell className={classes.valueCell}>QC1 In progress</TableCell>
                  <TableCell className={classes.valueCell}>
                    {moment(data.drawingQcAdmApprovedAt).format('DD-MM-YYYY hh:mm A')}
                  </TableCell>
                  <TableCell className={classes.valueCell}>
                    <FaDownload
                      onClick={() => handleOpen(data?.drawingQcAttachment, 'ADM Attachments')}
                      style={{ fontSize: "30px", color: "#355025", cursor: "pointer" }}
                    />
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {data?.drawingQCFirstRemarks}
                  </TableCell>
                </TableRow>
              )}

              {/* QC1 Approval */}
              {data?.drawingQcOneApprovedAt && (
                <TableRow>
                  <TableCell className={classes.valueCell}>{data?.qc1UserName}</TableCell>
                  <TableCell className={classes.valueCell}>QC1 Completed</TableCell>
                  <TableCell className={classes.valueCell}>
                    {moment(data.drawingQcOneApprovedAt).format('DD-MM-YYYY hh:mm A')}
                  </TableCell>
                  <TableCell className={classes.valueCell}>
                    <FaDownload
                      onClick={() => handleOpen(data?.drawingQcOneAttachment, 'QC1 QC Person Files')}
                      style={{ fontSize: "30px", color: "#355025", cursor: "pointer" }}
                    />
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {data?.qc1Remarks}
                  </TableCell>
                </TableRow>
              )}

              {/* QC2 Approval */}
              {Array.isArray(data?.drawingQCTwoApproveLogs) &&
                data.drawingQCTwoApproveLogs.length > 0 &&
                data.drawingQCTwoApproveLogs.map((log, index) => (
                  <TableRow key={log._id || index}>
                    <TableCell className={classes.valueCell}>{log.qcUserName}</TableCell>
                    <TableCell className={classes.valueCell}>{log.status}</TableCell>
                    <TableCell className={classes.valueCell}>
                      {log.changeStatusAt
                        ? moment(log.changeStatusAt).format('DD-MM-YYYY hh:mm A')
                        : 'N/A'}
                    </TableCell>
                    <TableCell className={classes.valueCell}>
                      <FaDownload
                        onClick={() => handleOpen(log.drawingQCTwoAttachment, log.status)}
                        style={{ fontSize: "30px", color: "#355025", cursor: "pointer" }}
                      />
                    </TableCell>
                    <TableCell className={classes.cell}>
                      {log.qc2Remarks}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* ADM Modal to display checklist PDF */}
      {data?.aDMChecklist && (
        <Dialog open={aDMModalOpen} onClose={handleCloseADMModal} maxWidth="lg" fullWidth>
          <DialogContent>
            <AdmCheckListPdf projectDetails={data} />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseADMModal} color="primary">Close</Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Dynamic Attachment Modal */}
      <Modal
        keepMounted
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={{
            ...styleForPopup,
            backgroundColor: '#f9f9f9',
            borderRadius: '10px',
            padding: '20px',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
            maxWidth: '600px',
            width: '90%',
          }}
        >
          <Typography variant="h6" align="center" sx={{ fontWeight: 'bold', mb: 2 }}>
            {modalTitle}
          </Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="center" style={{ fontWeight: 'bold', background: '#F47E46', color: 'white' }}>Attachments</TableCell>
                <TableCell align="center" style={{ fontWeight: 'bold', background: '#F47E46', color: 'white' }}>Download</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {[
                { label: 'Site Masking Documents', key: 'siteMaskingDocuments' },
                { label: '2D Drawings', key: 'twoDDrawingsFile' },
                { label: 'Site Photos/Videos', key: 'sitePhotosVideosFile' },
                { label: 'Appliances Checklist', key: 'appliancesChecklistFile' },
                { label: '3D PowerPoint (PPT)', key: 'powerPointFile' },
                { label: 'Quotation', key: 'quotationFile' },
              ].map((item, index) => (
                selectedFiles?.[item.key]?.length > 0 && (
                  <TableRow key={index} sx={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f1f1f1' }}>
                    <TableCell align="center">{item.label}</TableCell>
                    <TableCell align="center">
                      {(modalTitle === 'ADM Attachments' || modalTitle === 'QC2 In Progress') && item.label === 'Quotation' ? (
                        <FaExternalLinkAlt
                          onClick={() => quoClick(selectedFiles?.[item.key])}
                          style={{
                            cursor: 'pointer',
                            fontSize: '25px',
                            color: '#355025',
                            transition: 'transform 0.2s, color 0.2s',
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.color = '#1C375D';
                            e.currentTarget.style.transform = 'scale(1.2)';
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.color = '#355025';
                            e.currentTarget.style.transform = 'scale(1)';
                          }}
                        />
                      ) : (
                        <FaDownload
                          onClick={() => handleDownloadAll(selectedFiles?.[item.key])}
                          style={{
                            cursor: 'pointer',
                            fontSize: '25px',
                            color: '#355025',
                            transition: 'transform 0.2s, color 0.2s',
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.color = '#1C375D';
                            e.currentTarget.style.transform = 'scale(1.2)';
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.color = '#355025';
                            e.currentTarget.style.transform = 'scale(1)';
                          }}
                        />
                      )}
                    </TableCell>
                  </TableRow>
                )
              ))}
              {modalTitle === 'ADM Attachments' && (
                <TableRow sx={{ backgroundColor: '#f1f1f1' }}>
                  <TableCell align="center">ADM Checklist</TableCell>
                  <TableCell align="center">
                    <IoMdEye
                      onClick={handleOpenADMModal}
                      style={{
                        fontSize: "30px",
                        color: "#FDB913",
                        cursor: "pointer",
                        transition: 'transform 0.2s',
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = 'scale(1.2)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </Modal>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(DrawingQCLogs);